/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnsetUserGachaEnhancementResponse } from '../../models/unset-user-gacha-enhancement-response';

export interface UserServiceUnsetUserGachaEnhancement$Params {
  userUuid: string;
  gachaId: string;
  discordId?: string;
  gachaInstanceId?: string;
}

export function userServiceUnsetUserGachaEnhancement(http: HttpClient, rootUrl: string, params: UserServiceUnsetUserGachaEnhancement$Params, context?: HttpContext): Observable<StrictHttpResponse<UnsetUserGachaEnhancementResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceUnsetUserGachaEnhancement.PATH, 'delete');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.path('gachaId', params.gachaId, {});
    rb.query('discordId', params.discordId, {});
    rb.query('gachaInstanceId', params.gachaInstanceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnsetUserGachaEnhancementResponse>;
    })
  );
}

userServiceUnsetUserGachaEnhancement.PATH = '/api/v3/gateway/user/{userUuid}/gacha/{gachaId}/enhancement';
